import {call, put, takeLatest} from 'redux-saga/effects'

import {
  GET_SHOWROOM_LOCATIONS,
  getShowroomLocationsFailure,
  getShowroomLocationsPending,
  getShowroomLocationsSuccess,
} from '../actions/showroomLocations'

import * as api from '../api/api'

import {STATE_HASH} from '../const'

// Get Showroom Locations
// ----------------------------------------------------------------------------

export function* getShowroomLocationsWorker() {
  try {
    yield put(getShowroomLocationsPending())

    const response = yield call(api.getShowroomLocations)

    const results = api.onStatus({
      OK: ({json}) => json,
      DEFAULT: ({statusText}) => {
        throw new Error(`Could not get showroom locations: ${statusText}`)
      },
    })(response)

    // Temporary Phase1 proxy until we get the correct stateLocation fields in the MyTime api call.
    const updatedLocations = results.locations.map((location) => ({
      ...location,
      stateLocation: STATE_HASH[location.state],
    }))

    yield put(getShowroomLocationsSuccess(updatedLocations))
  } catch (e) {
    yield put(getShowroomLocationsFailure(new Error('Could not get showroom locations.')))
  }
}

export function* getShowroomLocationsSaga() {
  yield takeLatest(GET_SHOWROOM_LOCATIONS, getShowroomLocationsWorker)
}
